import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "popUpWindow" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1)
const _hoisted_3 = { for: "password" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { for: "password_confirmation" }
const _hoisted_6 = { class: "something_wrong" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "grayWide c-mt-6" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-R" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("forgotten_password.title")), 1),
    _hoisted_2,
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("forgotten_password.enter_new_password")), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.password }])
    }, [
      _createVNode(_component_Password, {
        id: "password",
        "toggle-mask": true,
        modelValue: _ctx.password,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
        name: "password",
        "medium-regex": _ctx.mediumPattern.source,
        "strong-regex": _ctx.strongPattern.source
      }, null, 8, ["modelValue", "medium-regex", "strong-regex"]),
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("forgotten_password.new_password")), 1),
      (_ctx.errors.password)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.errors.password), 1))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t("forgotten_password.repeat_password")), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.password_confirmation }])
    }, [
      _createVNode(_component_Password, {
        id: "password_confirmation",
        "toggle-mask": true,
        modelValue: _ctx.password_confirmation,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password_confirmation) = $event)),
        name: "password_confirmation",
        feedback: false
      }, null, 8, ["modelValue"]),
      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("forgotten_password.confirm_password")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.errors.password_confirmation), 1)
    ], 2),
    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.errors.token) + " " + _toDisplayString(_ctx.errors.something_wrong), 1),
    _hoisted_7,
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"])),
      class: "defaultButton next c-mt-2"
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("forgotten_password.submit")) + " ", 1),
      _hoisted_8
    ])
  ]))
}